import React from 'react';
import MaterialTableRow from '@mui/material/TableRow';
import type {TableRowProps as MaterialTableRowProps} from '@mui/material/TableRow';
import {styled} from '@mui/material/styles';

export type TableRowProps = MaterialTableRowProps;

const StyledTableRow = styled(MaterialTableRow)(({theme}) => ({
    '&.MuiTableRow-root': {
        borderBottom: `1px solid ${theme.tokens.FuelColorBorderLight}`,
        '&:last-child': {
            border: 0
        }
    }
}));

export const TableRow = React.forwardRef<any, TableRowProps>(({
    children, ...props
},
ref) => (
    <StyledTableRow
        ref={ref}
        {...props}
    >
        {children}
    </StyledTableRow>
));

TableRow.displayName = 'TableRow';
